import { Image } from "antd";
import { useImageLoader } from "../../components/customHook/ImageLoader";
import noImage from "../../assets/no-image.avif";

const ImagePreview = ({ file }) => {
  const { imageUrl } = useImageLoader(file?.resourceId);

  return (
    <div className="img-prev-cm">
      <Image
        preview={true}
        height={"50px"}
        width={"auto"}
        src={imageUrl}
        fallback={noImage}
        style={{
          border: "1px solid #ccc",
          padding: "2px",
        }}
      />
    </div>
  );
};
export { ImagePreview };
